var map = {
  "./cs.json": [
    "u6X",
    [
      "0x"
    ]
  ],
  "./en.json": [
    "btj",
    [
      "pj"
    ]
  ],
  "./pl.json": [
    "Nj",
    [
      "r6k"
    ]
  ],
  "./ru.json": [
    "l14",
    [
      "f0"
    ]
  ],
  "./tr.json": [
    "u0m",
    [
      "or"
    ]
  ],
  "./ja.json": [
    "Ig",
    [
      "a88"
    ]
  ],
  "./zh.json": [
    "Iwh",
    [
      "ig"
    ]
  ],
  "./pt-br.json": [
    "vv4",
    [
      "p89"
    ]
  ],
  "./de.json": [
    "VPY",
    [
      "by"
    ]
  ],
  "./es.json": [
    "iu",
    [
      "0c"
    ]
  ],
  "./fr.json": [
    "jN",
    [
      "1d"
    ]
  ],
  "./it.json": [
    "AKh",
    [
      "q6q"
    ]
  ],
  "./ko.json": [
    "ZVG",
    [
      "nyh"
    ]
  ],
  "./pt.json": [
    "b5o",
    [
      "t"
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = "LB";
module.exports = __rspack_async_context;
